import React from "react";
import Header from "../../component/Header/Header";
import "./LandingPage.css";
import { Card, Button } from "@mui/joy";
import {
  Laptop,
  BookOpen,
  Balloon,
  NotePencil,
  UserCircle,
  Desktop,
  HandsClapping,
  ChatCircleText,
  MapTrifold,
  Newspaper,
  Buildings,
  Ticket,
  DotsThreeCircle,
  CheckCircle,
  TwitterLogo,
  InstagramLogo,
  // CaretRight,
} from "@phosphor-icons/react";
import Drawer from "../../component/Drawer/Drawer";

const faqs = [
  {
    question: "アプリの導入までに時間はどれくらいかかりますか？",
    answer:
      "お申し込みから最短で2週間での導入が可能です。\nより具体的なスケジュールについては、お問い合わせいただけますと幸いです。",
  },
  {
    question: "このアプリの利用料金はいくらですか？",
    answer:
      "アプリのダウンロード、および利用料は完全無料です。※アプリご利用に伴う通信費用のみユーザー様のご負担になります。",
  },
  {
    question: "アプリを導入する際、学祭主催者側に費用はかかりますか？",
    answer:
      "本サービスの提供初年度である2023年度は、皆様により広くご利用いただきたいという思いから無料でのご提供を行います。\n2023年度は試験的にご活用いただくことでより多くのフィードバックをいただき、サービスの向上を図っていく所存です。\nただし、2024年度以降は有償でのご提供を予定しておりますので、ぜひこの機会にご利用いただけますと幸いです。\n※ 2024年度以降のご提供金額やご契約形態につきましては現状未確定でございます。予めご了承ください。",
  },
  {
    question: "アプリに表示する学祭データはどのように入力するのですか？",
    answer:
      "学祭主催者様1団体につき1つ、学祭データ管理用のアカウントを発行いたしますので、そちらでWebの管理画面にログインしてご入力いただきます。",
  },
  {
    question: "1年だけ利用したいのですが、契約年数の縛りなどはありますか？",
    answer:
      "いいえ、ございません。単年のご契約となりますので、次年度以降のご利用は都度ご検討いただけます。",
  },
  {
    question: "導入したいが、導入後のアプリのイメージが湧かない",
    answer:
      "前年の学祭パンフレットなどの詳細情報をご共有いただければ、学祭に応じた入力イメージや公開イメージを提案可能です。\nご不明点はご気軽にお問い合わせください。",
  },
  {
    question: "規模の小さな学祭ですが導入することは可能ですか？",
    answer:
      "はい、可能です。学祭の規模に関わらずご利用いただけるアプリとなっております。",
  },
  {
    question: "お試しで使用することは可能ですか？",
    answer:
      "はい、可能です。関係者のみに限定公開することが可能です。アプリを使用してみて実際に導入するかご検討いただけます。",
  },
  {
    question: "投票機能はどのようなイベントで使用できますか？",
    answer:
      "ミスコンやミスターコン、カラオケコンテストなど、ユーザーの投票を必要とする様々なイベントで利用可能です。",
  },
  {
    question: "'投票機能のみ'などの一部の機能だけを利用することも可能ですか？",
    answer:
      "はい、可能です。不要な機能は非表示にすることが可能です。※一部非表示にできない機能があります。",
  },
  {
    question:
      "同じ大学で複数のキャンパスに分かれて学祭が開催されますが、１つの学祭として公開可能ですか？",
    answer:
      "はい、可能です。アプリの規模によっては別々の学祭に分けて公開いただく方が利便性が上がることがあります。",
  },
  {
    question: "導入時のサポートではどのようなサポートを受けられますか？",
    answer:
      "入力方法、カスタマイズ方法など導入に関わるご質問やトラブル対応を行います。\n管理画面にチャット機能がありますのでチャット機能からお問い合わせください。",
  },
  {
    question: "どのようなデバイスで利用できますか？",
    answer: "iOS、Androidのスマートフォンでご利用可能です。",
  },
  // {
  //   question: "ユーザーの個人情報はどのように保護されますか？",
  //   answer:
  //     "ユーザーのログイン情報などの個人情報を含む機微な情報はGoogleなどの外部のサービスを使用しているため、当アプリでは個人情報を一切保存しておりません。そのため安心してご利用いただけます。詳しくはプライバシーポリシー及び利用規約をご確認ください。",
  // },
  {
    question: "トラブル発生時のサポート体制はどうなっていますか？",
    answer:
      "ベストエフォートの対応となります。チャット、メールでのサポートが可能です。",
  },
  {
    question: "機能を追加したりカスタマイズしていただくことは可能ですか？",
    answer:
      "基本的にご利用時に公開されている機能のみのご利用となりますが、上記のようなご要望ありましたらお気軽にお問い合わせください。\nベストエフォートで対応いたします。",
  },
  {
    question: "高校の学祭にも導入可能ですか？",
    answer:
      "本アプリは大学、専門学校のみのアプリとなっておりますので、小学校、中学校、高校などの学祭にはご利用いただけません。",
  },
];

const LandingPage: React.FC = () => {
  const [open, setOpen] = React.useState<boolean>(false);

  const handleNaviToggle = () => {
    setOpen(true);
  };

  const formUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSfJXUfEx7M6XLWaPXVuv7bj37qwq9uvFlvXbzHZrDZiI42qOw/viewform?usp=pp_url";
  const instagramUrl = "https://www.instagram.com/campuspocket_official";
  const twitterUrl = "https://twitter.com/campoke_info";
  const appStoreUrl = "https://apps.apple.com/jp/app/campuspocket/id6461417915";
  const googlePlayUrl =
    "https://play.google.com/store/apps/details?id=com.campus_pocket.campus_pocket";

  return (
    <div className="container">
      <Header onNaviToggle={handleNaviToggle} />
      <div className="main-visual-area">
        <div className="main-visual-catchcopy-area">
          <div className="main-visual-catchcopy-inner">
            <div className="main-visual-title">学祭アプリで、</div>
            <div
              className="main-visual-title"
              style={{ paddingBottom: "10px" }}
            >
              学祭をもっとスマートに
            </div>
            <div
              className="main-visual-subtitle"
              style={{ paddingBottom: "15px" }}
            >
              正式サービスの提供を開始しました！！
            </div>
            <div className="main-visual-button-area">
              <Button
                className="button-fill"
                style={{ marginRight: "10px" }}
                href=""
                onClick={() => {
                  window.open(formUrl, "_blank");
                }}
              >
                お申し込み
              </Button>
              <Button
                className="button-outline"
                href=""
                onClick={() => {
                  window.open("/web/install", "_blank");
                }}
              >
                ダウンロード
              </Button>
            </div>
          </div>
        </div>
        <div className="main-visual-img-area">
          <div className="main-visual-img-list slideshow">
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(255, 232, 27)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-map2.png"
                alt="ショップのイメージ"
              />
            </div>
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(83, 131, 221)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-event.png"
                alt="ショップのイメージ"
              />
            </div>
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(221, 83, 83)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-shop.png"
                alt="ショップのイメージ"
              />
            </div>
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(83, 221, 111)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-now.png"
                alt="ショップのイメージ"
              />
            </div>
          </div>
          <div className="main-visual-img-list slideshow">
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(255, 232, 27)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-map2.png"
                alt="ショップのイメージ"
              />
            </div>
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(83, 131, 221)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-event.png"
                alt="ショップのイメージ"
              />
            </div>
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(221, 83, 83)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-shop.png"
                alt="ショップのイメージ"
              />
            </div>
            <div
              className="main-visual-img-area-inner"
              style={{ backgroundColor: "rgb(83, 221, 111)" }}
            >
              <img
                className="main-visual-img-area-img"
                src="/web/images/iphone-now.png"
                alt="ショップのイメージ"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="subtitle" style={{ marginTop: "100px" }}>
        どんなアプリ？
      </div>
      <div className="merit-subtitle">
        <b className="logo">Campus Pocket</b>{" "}
        は大学・専門学校の学祭のポータルアプリです。
      </div>
      <div className="merit-area">
        <Card className="merit-card" variant="plain">
          <div>
            <div className="circle">
              <Laptop size={32} color="#FFFFFF" weight="fill" />
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            アプリ開発は不要、データ入力だけ
          </div>
          <div>
            高度な開発スキルは不要。データを入力するだけで、すぐにアプリを公開できます。
            <br />
            学祭の準備は既に十分に大変なもの。だからこそ、私たちはその負担を軽減するお手伝いをします。
          </div>
        </Card>
        <Card className="merit-card" variant="outlined">
          <div>
            <div className="circle">
              <BookOpen size={32} color="#FFFFFF" weight="fill" />
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            パンフレットの新たな形
          </div>
          <div>
            紙のパンフレットの代わりに、情報がすぐにアクセスできるアプリで、あなたの学祭体験をもっと便利にしましょう。
            <br />
            もちろん、アプリは既存のパンフレットを補完する役割も果たします。
          </div>
        </Card>
        <Card className="merit-card" variant="outlined">
          <div>
            <div className="circle">
              <Balloon size={32} color="#FFFFFF" weight="fill" />
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            リアルタイム情報更新で混乱を防ぐ
          </div>
          <div>
            万が一、急なイベントの日程変更が発生しても安心。更新した情報はすぐにアプリに反映されます。
            <br />
            これで学祭の進行をスムーズに、混乱なく進められます。
          </div>
        </Card>
      </div>
      <div className="subtitle" style={{ marginTop: "100px" }}>
        <span className="logo" style={{ fontSize: "26px" }}>
          Campus Pocket
        </span>{" "}
        の特徴
      </div>
      <div className="contents-area">
        <div className="contents-inner" style={{ marginTop: "30px" }}>
          <div className="contents-visual-area">
            <div
              className="contents-visual-area-inner"
              style={{ backgroundColor: "rgb(197, 217, 255)" }}
            >
              <img
                className="contents-visual-area-img-top"
                src="/web/images/iphone-shop.png"
                alt="ショップのイメージ"
              />
              <img
                className="contents-visual-area-img-bottom"
                src="/web/images/iphone-event.png"
                alt="ショップのイメージ"
              />
            </div>
          </div>
          <div className="contents-description-area">
            <div className="contents-title">出店展示・イベント</div>
            <div className="contents-subtitle" style={{ marginBottom: "30px" }}>
              出店展示・イベント情報をリアルタイムで確認
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#4A6CF7"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                出店、展示、イベントの詳細情報を入力可能
              </div>
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#4A6CF7"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                イベントのタイムスケジュールを設定
              </div>
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#4A6CF7"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                各団体の代表者に入力してもらうことも可能
              </div>
            </div>
          </div>
        </div>
        <div className="contents-inner">
          <div className="contents-description-area">
            <div className="contents-title">マップ</div>
            <div className="contents-subtitle" style={{ marginBottom: "30px" }}>
              位置情報と連動したマップで場所を確認
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#A09107"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                管理画面からピンを設定して、位置情報と連動したマップ機能を作成
              </div>
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#A09107"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                マップのデザインはいくつかのフォーマットから選択可能
              </div>
            </div>
          </div>
          <div className="contents-visual-area">
            <div
              className="contents-visual-area-inner"
              style={{ backgroundColor: "rgb(255, 249, 198)" }}
            >
              <img
                className="contents-visual-area-img-top"
                src="/web/images/iphone-map1.png"
                alt="ショップのイメージ"
              />
              <img
                className="contents-visual-area-img-bottom"
                src="/web/images/iphone-map2.png"
                alt="ショップのイメージ"
              />
            </div>
          </div>
        </div>
        <div className="contents-inner">
          <div className="contents-visual-area">
            <div
              className="contents-visual-area-inner"
              style={{ backgroundColor: "rgb(255, 214, 197)" }}
            >
              <img
                className="contents-visual-area-img-center"
                src="/web/images/iphone-contest.png"
                alt="ショップのイメージ"
              />
            </div>
          </div>
          <div className="contents-description-area">
            <div className="contents-title">投票</div>
            <div className="contents-subtitle" style={{ marginBottom: "30px" }}>
              コンテストの投票機能で学祭を盛り上げましょう
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#DD5353"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                ミスコン・ミスターコンなどのコンテストの投票機能を作成
              </div>
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#DD5353"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                １回のみ、１日１回などいくつかの投票サイクルを設定して、コンテストにマッチした投票機能を提供可能
              </div>
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#DD5353"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                ログインユーザーのみ投票可能なため、不正行為を未然に防ぐことが可能
              </div>
            </div>
            {/* <div className="contents-sentence">
              <div className="introduction-sentence">
                <CheckCircle
                  style={{ marginRight: "15px" }}
                  size={32}
                  color="#4A6CF7"
                  weight="duotone"
                />
                <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                １日１回、１回のみなどいくつかの投票サイクルを設定して、コンテストにマッチした投票機能を提供可能
                </div>
              </div>
            </div> */}
            {/* <div className="contents-sentence">
              <div className="introduction-sentence">
                <CheckCircle
                  style={{ marginRight: "15px" }}
                  size={32}
                  color="#4A6CF7"
                  weight="duotone"
                />
                <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                不正防止のため、ログインユーザーのみ投票可能
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="contents-inner">
          <div className="contents-description-area">
            <div className="contents-title">デザイン</div>
            <div className="contents-subtitle" style={{ marginBottom: "30px" }}>
              デザインをカスタマイズして自分たちだけのアプリを作りましょう
            </div>
            <div className="introduction-sentence">
              <CheckCircle
                className="check-circle"
                size={32}
                color="#53DD6F"
                weight="duotone"
              />
              <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                配色のテーマ、フォントなどをカスタマイズ可能
              </div>
            </div>
          </div>
          <div className="contents-visual-area">
            <div
              className="contents-visual-area-inner"
              style={{ backgroundColor: "rgb(225, 255, 197)" }}
            >
              <img
                className="contents-visual-area-img-top"
                src="/web/images/iphone-event.png"
                alt="ショップのイメージ"
              />
              <img
                className="contents-visual-area-img-top-right"
                src="/web/images/iphone-event2.png"
                alt="ショップのイメージ"
              />
            </div>
          </div>
        </div>
        <div className="function-area" style={{ marginTop: "30px" }}>
          <Card className="function-card" variant="outlined">
            <div>
              <div className="circle">
                <ChatCircleText size={32} color="#FFFFFF" />
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Now
            </div>
            <div>
              SNSのタイムラインのように、運営出店団体からリアルタイムに発信ができます。
            </div>
          </Card>
          <Card className="function-card" variant="outlined">
            <div>
              <div className="circle">
                <MapTrifold size={32} color="#FFFFFF" />
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              フロアマップ
            </div>
            <div>
              マップ機能で提供できない室内マップを設定することができます。
            </div>
          </Card>
          <Card className="function-card" variant="outlined">
            <div>
              <div className="circle">
                <Newspaper size={32} color="#FFFFFF" />
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              ニュース
            </div>
            <div>開催までの盛り上げや、案内に活用できます。</div>
          </Card>
          <Card className="function-card" variant="outlined">
            <div>
              <div className="circle">
                <Buildings size={32} color="#FFFFFF" />
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              協賛
            </div>
            <div>
              協賛団体名や紹介文、Webサイトへのリンクなどの情報を掲載できます。
            </div>
          </Card>
          <Card className="function-card" variant="outlined">
            <div>
              <div className="circle">
                <Ticket size={32} color="#FFFFFF" />
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              クーポン
            </div>
            <div>
              物品協賛の引換券や、協賛企業で使用できるクーポンを作成できます。
            </div>
          </Card>
          <Card className="function-card" variant="outlined">
            <div>
              <div className="circle">
                <DotsThreeCircle size={32} color="#FFFFFF" />
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              その他
            </div>
            <div>
              キャンパスまでのアクセスや、お知らせ、注意事項など必要な情報を掲載する機能が全て揃っています。
            </div>
          </Card>
        </div>
        <div className="price-area" style={{ marginTop: "30px" }}>
          <div className="subtitle">料金</div>
          <div className="price-card-outer">
            {/* <Card className="price-card" variant="outlined">
              <div style={{ textAlign: "center" }}>
                2023年度〜永年
              </div>
              <div className="price-card-subtitle">
                <b>アプリダウンロード＆利用料</b>
              </div>
              <div className="price-card-title">0円</div>
              <div style={{
                textAlign: "center",
                fontSize: "12px",
              }}>
                通信料のみご負担いただきます。
              </div>
              <Button
                className="button-fill"
                style={{ width: "100%" }}
                onClick={() => {
                  window.open(appStoreUrl, "_blank");
                }}
              >
                <div
                  style={{
                    height: "100%",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "inline-flex",
                  }}
                >
                  デモを試す
                </div>
              </Button>
            </Card> */}
            <Card className="price-card" variant="outlined">
              <div style={{ textAlign: "center" }}>2023年度</div>
              <div className="price-card-subtitle">
                <b>ライセンス登録料</b>
              </div>
              <div className="price-card-title">無料</div>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                }}
              >
                提供開始年度のみの特別料金です！
              </div>
              <Button
                className="button-fill"
                style={{ width: "100%" }}
                onClick={() => {
                  window.open(formUrl, "_blank");
                }}
              >
                <div
                  style={{
                    height: "100%",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "inline-flex",
                  }}
                >
                  お申し込み
                </div>
              </Button>
            </Card>
            <Card className="price-card" variant="outlined">
              <div style={{ textAlign: "center" }}>2024年度〜</div>
              <div className="price-card-subtitle">
                <b>ライセンス登録料</b>
              </div>
              <div className="price-card-title">検討中</div>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                }}
              >
                決定次第、掲載いたします。
              </div>
              <a href="#faq">
                <Button className="button-fill" style={{ width: "100%" }}>
                  <div
                    style={{
                      height: "100%",
                      position: "relative",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "inline-flex",
                    }}
                  >
                    詳細はよくある質問へ
                  </div>
                </Button>
              </a>
            </Card>
          </div>
        </div>
      </div>
      {/* <div className="subtitle">導入実績</div>
      <div
        style={{
          width: "100%",
          textAlign: "center",
          paddingTop: "10px",
          fontSize: "24px",
          padding: "15px 10px 0 10px",
        }}
      >
        熊本県立大学の学生とOBが共同で制作しています。
      </div>
      <div className="archivement-area">
        <Card className="archivement-card" variant="outlined">
          <div>
            <div className="square">
              <img src="/web/images/hakuasai2016.png" alt="白亜祭2016"></img>
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            白亜祭 2016
          </div>
        </Card>
        <Card className="archivement-card" variant="outlined">
          <div>
            <div className="square">
              <img src="/web/images/hakuasai2017.png" alt="白亜祭2017"></img>
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            白亜祭 2017
          </div>
        </Card>
        <Card className="archivement-card" variant="outlined">
          <div>
            <div className="square">
              <img src="/web/images/campus-pocket.png" alt="白亜祭2019"></img>
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            白亜祭 2019
          </div>
        </Card>
      </div> */}
      <div className="introduction-area" style={{ marginTop: "30px" }}>
        <div className="introduction-inner">
          <div className="introduction-description-area">
            <div className="introduction-title ">学祭に導入する</div>
            <div className="introduction-subtitle">
              学祭にアプリを導入してみませんか？
              <br />
              不明点などはお気軽にお問い合わせください。
            </div>
            <div style={{ paddingTop: "25px", paddingBottom: "25px" }}>
              <div className="introduction-sentence">
                <CheckCircle
                  className="check-circle"
                  size={32}
                  color="#4A6CF7"
                  weight="duotone"
                />
                <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                  全機能が完全無料
                </div>
              </div>
              <div className="introduction-sentence">
                <CheckCircle
                  className="check-circle"
                  size={32}
                  color="#4A6CF7"
                  weight="duotone"
                />
                <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                  管理画面からの入力のみの簡単導入
                </div>
              </div>
              <div className="introduction-sentence">
                <CheckCircle
                  className="check-circle"
                  size={32}
                  color="#4A6CF7"
                  weight="duotone"
                />
                <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
                  導入サポートあり
                </div>
              </div>
            </div>
            <Button
              className="button-fill"
              style={{ marginRight: "15px" }}
              onClick={() => {
                window.open(formUrl, "_blank");
              }}
            >
              お申し込み
            </Button>
          </div>
          <div className="introduction-visual-area">
            <div className="introduction-visual-area-inner">
              <img
                className="introduction-visual-area-img-center-top"
                src="/web/images/app-image.png"
                alt="ショップのイメージ"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="subtitle" style={{ marginTop: "100px" }}>
        導入までの流れ
      </div>
      <div className="flow-subtitle" style={{ marginBottom: "25px" }}>
        アプリ公開まで最短 <span>２週間 </span>！
      </div>
      <div className="flow-area">
        <div className="flow-item">
          <Card className="flow-card" variant="outlined">
            <div className="flow-circle">1</div>
            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
                paddingBottom: "15px",
              }}
            >
              お申し込み
            </div>
            <div>
              <div className="square2">
                <NotePencil size={72} color="#4A6CF7" weight="duotone" />
              </div>
            </div>
            <div style={{ paddingTop: "15px" }}>
              申請フォーマットに必要な情報を入力し、お申し込みください。
            </div>
          </Card>
        </div>
        <div className="flow-arrow-area">
          <div className="flow-arrow"></div>
        </div>
        <div className="flow-item">
          <Card className="flow-card" variant="outlined">
            <div className="flow-circle">2</div>
            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
                paddingBottom: "15px",
              }}
            >
              アカウント発行
            </div>
            <div>
              <div className="square2">
                <UserCircle size={72} color="#4A6CF7" weight="duotone" />
              </div>
            </div>
            <div style={{ paddingTop: "15px" }}>
              ９月以降、管理ページの登録アカウント発行し、ご連絡いたします。
            </div>
          </Card>
        </div>
        <div className="flow-arrow-area">
          <div className="flow-arrow"></div>
        </div>
        <div className="flow-item">
          <Card className="flow-card" variant="outlined">
            <div className="flow-circle">3</div>
            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
                paddingBottom: "15px",
              }}
            >
              データ入力
            </div>
            <div>
              <div className="square2">
                <Desktop size={72} color="#4A6CF7" weight="duotone" />
              </div>
            </div>
            <div style={{ paddingTop: "15px" }}>
              学祭情報の入力や、画像のアップロードを行ってください。
            </div>
          </Card>
        </div>
        <div className="flow-arrow-area">
          <div className="flow-arrow"></div>
        </div>
        <div className="flow-item">
          <Card className="flow-card" variant="outlined">
            <div className="flow-circle">4</div>
            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
                paddingBottom: "15px",
              }}
            >
              一般公開
            </div>
            <div>
              <div className="square2">
                <HandsClapping size={72} color="#4A6CF7" weight="duotone" />
              </div>
            </div>
            <div style={{ paddingTop: "15px" }}>
              任意のタイミングで公開が可能です。また、限られたユーザーへの限定公開も可能です。
            </div>
          </Card>
        </div>
      </div>
      <div id="faq" className="subtitle" style={{ marginTop: "100px" }}>
        よくある質問
      </div>
      <div className="faq-area">
        {faqs.map((faq) => (
          <Card className="faq-card" variant="outlined">
            <div className="faq-card-question">
              <span>Q.</span>
              {faq.question}
            </div>
            <div className="faq-card-answer" style={{ marginLeft: "5px" }}>
              {/* <span>A.</span> */}
              {faq.answer}
            </div>
          </Card>
        ))}
      </div>
      <div className="footer-area">
        <div className="footer-item-copyright">
          <span style={{ lineHeight: "28px", verticalAlign: "middle" }}>
            <span className="logo">©︎ 2023 CampusPocket</span>
          </span>
        </div>
        <div className="footer-item-sns">
          <TwitterLogo
            style={{ marginLeft: "10px" }}
            size={32}
            color="#333333"
            weight="fill"
            onClick={() => {
              window.open(twitterUrl, "_blank");
            }}
          />
          <InstagramLogo
            style={{ marginLeft: "10px" }}
            size={32}
            color="#333333"
            weight="fill"
            onClick={() => {
              window.open(instagramUrl, "_blank");
            }}
          />
        </div>
      </div>
      <Drawer
        title="Drawer Title"
        position="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open(formUrl, "_blank");
          }}
        >
          <div>申し込み</div>
          {/* <CaretRight size={16} color="#292929" /> */}
        </Button>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open(appStoreUrl, "_blank");
          }}
        >
          <div>デモを試す</div>
          {/* <CaretRight size={16} color="#292929" /> */}
        </Button>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open(formUrl, "_blank");
          }}
        >
          <div>お問い合わせ</div>
          {/* <CaretRight size={16} color="#292929" /> */}
        </Button>
        <div style={{ height: "30px" }}></div>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open(twitterUrl, "_blank");
          }}
        >
          <InstagramLogo size={24} color="#292929" />
          <div style={{ marginLeft: "15px" }}>Instagram</div>
        </Button>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open(instagramUrl, "_blank");
          }}
        >
          <TwitterLogo size={24} color="#292929" />
          <div style={{ marginLeft: "15px" }}>Twitter</div>
        </Button>

        <div style={{ height: "30px" }}></div>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open(appStoreUrl, "_blank");
          }}
        >
          <img
            src="/web/images/apple-logo.png"
            alt="apple-logo"
            style={{ height: "24px" }}
          />
          <div style={{ marginLeft: "15px" }}>iOS</div>
        </Button>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open(googlePlayUrl, "_blank");
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.406 1.33934C3.15 1.60234 3 2.01134 3 2.54134V21.4573C3 21.9873 3.149 22.3973 3.406 22.6603L3.47 22.7183L14.326 12.1223V11.8723L3.47 1.27734L3.406 1.33934Z"
              fill="black"
            ></path>
            <path
              opacity="0.2"
              d="M17.9412 15.6568L14.3262 12.1238V11.8738L17.9462 8.33984L18.0262 8.38584L22.3132 10.7658C23.5362 11.4428 23.5362 12.5548 22.3132 13.2348L18.0272 15.6108L17.9412 15.6568Z"
              fill="black"
            ></path>
            <path
              d="M18.0262 15.61L14.3262 11.998L3.40625 22.661C3.81225 23.078 4.47525 23.128 5.22825 22.711L18.0262 15.611V15.61Z"
              fill="black"
              fill-opacity="0.8"
            ></path>
            <path
              opacity="0.4"
              d="M18.0262 8.38621L5.22825 1.28621C4.47525 0.872216 3.81225 0.922216 3.40625 1.34021L14.3262 11.9992L18.0262 8.38621Z"
              fill="black"
            ></path>
          </svg>
          <div style={{ marginLeft: "15px" }}>Android</div>
        </Button>
        <div style={{ height: "30px" }}></div>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open("/web/privacy", "_blank");
          }}
        >
          プライバシーポリシー
        </Button>
        <Button
          className="drawer-list-button-outline"
          onClick={() => {
            window.open("/web/terms", "_blank");
          }}
        >
          利用規約
        </Button>
      </Drawer>
    </div>
  );
};

export default LandingPage;
